import { render, staticRenderFns } from "./saveParam.vue?vue&type=template&id=0c3760a2&scoped=true"
import script from "./saveParam.vue?vue&type=script&lang=js"
export * from "./saveParam.vue?vue&type=script&lang=js"
import style0 from "./saveParam.vue?vue&type=style&index=0&id=0c3760a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3760a2",
  null
  
)

export default component.exports